import React, { FC, InputHTMLAttributes } from "react";
import styled from "styled-components";

import { UI_SIZE } from "../../enums";
import { fontFamily } from "../../styles/global";
import { focusColor } from "../../styles/variables";

export const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  pointer-events: auto;

  span {
    display: flex;
    font-style: normal;
    line-height: 24px;
    ${fontFamily}
  }

  &:focus-visible {
    outline: 1px solid ${focusColor} !important;
  }
`;

export const SettingHeader = styled.span<{ uiSize: UI_SIZE }>`
  font-size: ${({ uiSize }) => (uiSize === UI_SIZE.LARGE ? "16px" : "14px")};
  font-weight: bold;
  cursor: pointer;
`;

export const Divider = styled.hr`
  background: #323639;
  border: none;
  height: 1px;
  margin: 16px 0;
  width: 100%;
`;

export const SettingMenu = styled.div<{ isMobile?: boolean }>`
  align-items: flex-start;
  display: flex;
  flex-direction: column;

  > :not(:first-child) {
    margin-top: 16px;
  }
`;

export const SettingOption = styled.div`
  display: flex;
  height: 21px;
`;

export const InputLabel = styled.label<{ uiSize: UI_SIZE }>`
  cursor: pointer;
  font-size: ${({ uiSize }) => (uiSize === UI_SIZE.LARGE ? "16px" : "14px")};
  font-style: normal;
  font-weight: bold;
  line-height: 21px;
  pointer-events: auto;
  ${fontFamily}
`;

const SettingInputStyled = styled.input`
  appearance: none;
  background-clip: content-box;
  background-color: ${props => props.theme.inputBackgroundColor};
  border-radius: 50%;
  border: ${props => props.theme.inputBorder};
  cursor: pointer;
  height: 21px;
  margin: 0 16px 0 0;
  padding: 3px;
  pointer-events: auto;
  width: 21px;

  &:checked {
    background-clip: content-box;
    background-color: #1abed1;
    border: 2px solid #1abed1;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;

    & + label {
      opacity: 0.5;
    }
  }
`;

const isKeyboardEvent = event =>
  event.nativeEvent.clientX === 0 && event.nativeEvent.clientY === 0;

export const SettingInput: FC<InputHTMLAttributes<HTMLInputElement>> = ({
  checked,
  onBlur,
  onClick,
  ...props
}) => (
  <SettingInputStyled
    onBlur={onBlur}
    autoFocus={checked}
    checked={checked}
    onClick={event => {
      if (!isKeyboardEvent(event) && onClick) {
        onClick(event);
      }
    }}
    type="radio"
    {...props}
  />
);
